module.exports = __webpack_public_path__ + "files/ecd03d45d3d791d80ea5cedca62c2eb8.png";